import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { connect } from 'react-redux';
import Toggle from 'react-toggle'
import "react-toggle/style.css"
import {
    TOKEN_CREATE,
    TOKEN_CREATE_PAGE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({
    ...state.token,
    currentUser: state.common.currentUser,
    inProgress: state.common.inProgress,
});

const mapDispatchToProps = dispatch => ({
    onSubmit: (payload) => {
        dispatch({ type: TOKEN_CREATE, payload })
    },
    onUnload: () =>
        dispatch({ type: TOKEN_CREATE_PAGE_UNLOADED })
});

class TokenAdd extends React.Component {
    constructor() {
        super();
        this.state = {
            symbol: '',
            name: '',
            total: '',
            fixed: false,
            logo_source: null,
            website: '',
            description: ''
        }

        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.handleFixedyChange = this.handleChange.bind(this, 'fixed')
        this.submitForm = (name, symbol, total, fixed, logo_source, website, description) => ev => {
            ev.preventDefault();
            const payload = agent.Tokens.createToken(name, symbol, total, fixed + '', website, description, logo_source)
            this.props.onSubmit(payload);
        }
    }
    componentWillMount(props) {
        if (this.props.currentUser) {
            Object.assign(this.state, {
            })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }
    handleChange(key, event) {
        this.setState({ [key]: event.target.checked })
    }
    render() {
        const name = this.state.name;
        const symbol = this.state.symbol;
        const total = this.state.total;
        const fixed = this.state.fixed;
        const website = this.state.website
        const description = this.state.description
        const logo_source = this.state.logo_source
        const inProgress = this.props.inProgress
        return (
            <div class='pane'>
                <Link className="crumb" to="/tokens">&laquo; back to tokens</Link>
                <h1>Add Prime Token</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(name, symbol, total, fixed, logo_source, website, description)}>
                    <fieldset className="form">
                        <strong>Name</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="Token Name"
                                value={name}
                                onChange={this.updateState('name')} />
                        </fieldset>
                        <strong>Symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="ABC"
                                value={symbol}
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>Total</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="1000000"
                                value={total}
                                onChange={this.updateState('total')} />
                        </fieldset>
                        <strong>Logo</strong>
                        <fieldset className="form-group">
                            <input type="file" onChange={e => this.setState({ logo_source: e.target.files[0] })} accept='image/*' />
                        </fieldset>

                        <strong>Website</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder=""
                                value={website}
                                onChange={this.updateState('website')} />
                        </fieldset>
                        <strong>Description</strong>
                        <fieldset className="form-group">
                            <textarea
                                rows="3"
                                placeholder=""
                                value={description}
                                onChange={this.updateState('description')} />
                        </fieldset>

                        <strong>Fixed</strong>
                        <fieldset className="form-group">
                            <Toggle id='fixed' defaultChecked={fixed} onChange={this.handleFixedChange} />
                        </fieldset>

                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Add
                            </button>
                        </fieldset>
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TokenAdd);



// WEBPACK FOOTER //
// ./src/components/TokenAdd.js